import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SeatSelection from './pages/SeatSelection';  // Adjust path if needed
import Layout from './Layout';

function App() {
  return (
    <Layout/>
  );
}

export default App;
